import { SnackBarActionType } from "../actiontype/snack-bar.actiontype";
import { SnackBarType } from "../constants/snack-bar.constant";

const initialState = {
    open: false,
    type: SnackBarType.SUCCESS,
    title: '',
    message: ''
}

export const SnackBarReducer = (state = initialState, action) => {
    switch (action.type) {
        case SnackBarActionType.OPEN_SNACK_BAR:
            return { ...state, ...action.payload }
        case SnackBarActionType.CLOSE_SNACK_BAR:
            return { ...initialState }
        default:
            return state
    }
}